import { Controller } from '@hotwired/stimulus';
import Chart from 'chart.js/auto';
import ChartLazyLoader from './chart_lazy_loader';

// Subclasses implement _buildChart(); it runs once the canvas nears the viewport.
export default class extends Controller {
  static targets = ['chartcanvas'];

  connect() {
    // An unbuilt canvas is 2:1 (300×150 intrinsic); charts with another ratio reserve it so building doesn't shift layout.
    if (this.constructor.aspectRatio) this.chartcanvasTarget.style.aspectRatio = this.constructor.aspectRatio;
    this.loader = new ChartLazyLoader(this.chartcanvasTarget, () => this._buildChart());
  }

  disconnect() {
    this.loader.disconnect();
    Chart.getChart(this.chartcanvasTarget)?.destroy();
  }
}
